/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import shaka from "shaka-player";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import videojs from "!video.js";

import { AdTracker } from "./types";

// transpiling issue with video.js, !syntax with disabled webpack loader required
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved

export const DEFAULT_TRACKER: AdTracker = {
  currentTime: 0,
  duration: 0,
  position: 0,
  totalAds: 0,
  skipTimeOffset: 0,
  skippable: false,
  muted: false,
  playing: false,
  title: "",
  description: "",
};

export class CurrentAdTracker {
  protected player: videojs.Player | shaka.Player;
  protected manager: google.ima.AdsManager;
  protected currentAd: google.ima.Ad | null = null;

  protected tracker: AdTracker = { ...DEFAULT_TRACKER };

  constructor(manager: google.ima.AdsManager, player: shaka.Player) {
    this.player = player;
    this.manager = manager;

    this.manager.addEventListener(
      google.ima.AdEvent.Type.AD_PROGRESS,
      this.onAdProgress,
    );
  }

  get ad(): google.ima.Ad | null {
    return this.currentAd;
  }

  get data() {
    return this.tracker;
  }

  start(ad: google.ima.Ad) {
    const skipTimeOffset = ad.getSkipTimeOffset();
    const skippable = skipTimeOffset !== -1;

    this.tracker = {
      ...DEFAULT_TRACKER,
      skipTimeOffset,
      skippable,
      playing: true,
      title: ad.getTitle(),
      description: ad.getDescription(),
    };

    if (ad.isLinear()) {
      this.currentAd = ad;
    }
  }

  stop() {
    if (this.currentAd?.isLinear()) {
      this.tracker = { ...DEFAULT_TRACKER };
    }
  }

  muted(state: boolean) {
    this.tracker.muted = state;
  }

  pause() {
    this.tracker.playing = false;
  }

  resume() {
    this.tracker.playing = true;
  }

  protected updateAdMetadata = () => {};

  protected onAdProgress = (event: google.ima.AdEvent) => {
    const {
      currentTime,
      duration,
      totalAds,
      adPosition: position,
    } = event.getAdData() as google.ima.AdProgressData;

    this.tracker = {
      ...this.tracker,
      currentTime,
      duration,
      position,
      totalAds,
    };

    this.updateAdMetadata();
  };
}
